// extracted by mini-css-extract-plugin
export default {"root":"WFevbiolfz-oV4VdhcbHBw=="};